import {Trans, useTranslation} from "react-i18next";
import './JsonSample.scss';
import {Tooltip as ReactTooltip} from "react-tooltip";
import React from "react";

export default function JsonSample() {

    const {t} = useTranslation();

    let json = '{"checklist":"checklist_name","items":[{"name":"parent_name 1","expanded":true,"items":[{"name":"child_name ' +
        '1","checked":true},{"name":"child_name 2","checked":false},{"name":"child_name 3","expanded":true,"items":[{"name":"child_name ' +
        '3.1","checked":true}]},{"name":"child_name 4","checked":true}]},{"name":"parent_name 2","expanded":true,"items":[{"name":' +
        '"child_name A","checked":false},{"name":"child_name B","checked":true}]}]}';
    json = json.replaceAll('checklist_name', t('index.json.checklistName')).replaceAll('parent_name', t('index.json.parentName')).replaceAll('child_name', t('index.json.childName'));
    const formatted = JSON.stringify(JSON.parse(json), null, 2);

    return (
        <>
            <div className='row'>
                <div className="col-12 mb-2">
                    {t('index.json.text')}
                </div>
            </div>
            <div className='row'>
                <div className="col-12 position-relative">
                    <pre className="p-3">{formatted}</pre>
                    <span data-tooltip-id="expanded" className="info small expanded position-absolute">i</span>
                    <ReactTooltip
                        id="expanded"
                        place="bottom"
                        variant="info"
                        className="genre-info long"
                        content={
                            <Trans i18nKey="index.json.expanded" components={[<i/>]}/>
                        }
                    />
                    <span data-tooltip-id="checked" className="info small checked position-absolute">i</span>
                    <ReactTooltip
                        id="checked"
                        place="bottom"
                        variant="info"
                        className="genre-info long"
                        content={
                            <Trans i18nKey="index.json.checked" components={[<i/>]}/>
                        }
                    />
                </div>
            </div>
        </>
    )

}